<template>
  <v-layout :align-center="!isMobile" justify-end v-bind="binding">
    <v-flex pr-2 :mb-2="isMobile">
      <span class="font-weight-bold">{{ $t('COMMON.SHOW') }}:</span>
    </v-flex>
    <v-flex mr-3 :mb-2="isMobile">
      <v-checkbox
        v-model="additional_filters.framed"
        color="primary"
        class="pa-0 ma-0"
        hide-details
        :label="$t('SEARCH.FRAMED')"
        :ripple="false"
        @change="change()"
      />
    </v-flex>
    <v-flex mr-3 :mb-2="isMobile">
      <v-checkbox
        v-model="additional_filters.ready_to_hang"
        color="primary"
        class="pa-0 ma-0"
        hide-details
        :label="$t('SEARCH.READY_TO_HANG')"
        :ripple="false"
        @change="change()"
      />
    </v-flex>
    <v-flex mr-3 :mb-2="isMobile">
      <v-checkbox
        v-model="additional_filters.video"
        color="primary"
        class="pa-0 ma-0"
        hide-details
        :label="$t('SEARCH.WITH_VIDEO')"
        :ripple="false"
        @change="change()"
      />
    </v-flex>
    <v-flex mr-3 :mb-2="isMobile">
      <v-checkbox
        v-model="additional_filters.for_sale"
        color="primary"
        class="pa-0 ma-0"
        hide-details
        :label="$t('SEARCH.FOR_SALE')"
        :ripple="false"
        @change="change()"
      />
    </v-flex>
  </v-layout>
</template>

<script>
/**
 * TODO/
 * Handling component state with route query is not quite optimal
 * Use filters props instead
 */
export default {
  data: () => ({
    additional_filters: {
      framed: false,
      ready_to_hang: false,
      for_sale: false,
      video: false,
    },
  }),

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    binding() {
      const binding = {};
      if (this.isMobile) binding.column = true;
      return binding;
    },
  },

  methods: {
    change () {
      this.$emit('change', this.additional_filters)
    }
  },

  created() {
    console.log("Created", this.$route.query);
    this.additional_filters.framed = this.$route.query.framed === "true";
    this.additional_filters.ready_to_hang =
      this.$route.query.ready_to_hang === "true";
    this.additional_filters.for_sale = this.$route.query.for_sale === "true";
    this.additional_filters.video = this.$route.query.video === "true";
  },
};
</script>
